import { memo, useRef } from 'react';
import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import useTitlePreivew from '@/hooks/pure/useTitlePreview';
import { EllipsisDiv } from '@/styles/style';

const FeedbackTitleDisplay = (props: FeedbackListItemT) => {
  const color = useColor();
  const feedback = props;
  const titleRef = useRef<HTMLDivElement>(null);

  const {
    displayFullTitlePos,
    handleMouseEnterEvent,
    handleMouseLeaveEvent,
    tooltipNode,
  } = useTitlePreivew({
    ref: titleRef,
    text: feedback.title || 'Untitled',
  });

  return (
    <>
      <Style g="8px" a="center">
        <EllipsisDiv
          style={{ width: 'calc(100% - 24px)' }}
          ref={titleRef}
          onMouseEnter={(e) => handleMouseEnterEvent(e)}
          onMouseLeave={handleMouseLeaveEvent}
        >
          <Typo
            type="label2"
            color={color.gray800}
            className="feedback-list-title-span"
          >
            {feedback.title || 'Untitled'}
          </Typo>
        </EllipsisDiv>
      </Style>
      {feedback.title && displayFullTitlePos && tooltipNode}
    </>
  );
};

const Style = styled(Flex)`
  width: 100%;
  height: 40px;
  padding: 0 8px;
  border: 1px solid ${(props) => props.theme.colors.ND00};
  border-radius: 4px;
  transition: border 0.1s;
  &:hover {
    border-color: ${(props) => props.theme.colors.gray500};
  }
`;

export default memo(FeedbackTitleDisplay);
